import { Injectable } from '@angular/core';
import { Subject, take, takeUntil } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class WhiteLabelService {

    cssConfigColors: Subject<any> = new Subject()

    private _hasCSSConfig: boolean = false;

    get hasCSSConfig(): boolean {
        return this._hasCSSConfig;
    }

    set hasCSSConfig(value: boolean) {
        this._hasCSSConfig = value;
    }

    constructor() {
        this.setup()
    }

    setup() {
        this.cssConfigColors.pipe(take(1)).subscribe((colors) => {
            if (colors) {
                this.hasCSSConfig = true;
            }

            this.setCSSVariables({
                '--room-background-color': colors?.brand || '#9d6fb0',
                '--room-translucent-background-color': colors?.brand ? colors?.brand + '90' : '#9d6fb090',
                '--room-accent-color': colors?.accent || '#341c4c',
                '--room-controls-background-color': colors?.brand ? this.isColorDark(colors?.brand) ? '#cfcfcf30' : '#00000030' : '#00000030',
                '--session-control-color': colors && colors?.brand !== '#8b5a9a' ? "#000000" : '#8b5a9a'
            })
        })
    }

   setCSSVariables(variables: { [key: string]: string }) {
       for (const [key, value] of Object.entries(variables)) {
           document.documentElement.style.setProperty(key, value);
       }
   }

   hexToRgb(hex: string) {
        hex = hex.replace(/^#/, '');

        let r = parseInt(hex.substring(0, 2), 16);
        let g = parseInt(hex.substring(2, 4), 16);
        let b = parseInt(hex.substring(4, 6), 16);

        return { r, g, b };
    }

    getLuminance(r: number, g: number, b: number) {
        let a = [r, g, b].map((v) => {
            v /= 255;
            return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
        });

        return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2];
    }

    isColorDark(hex: string) {
        const { r, g, b } = this.hexToRgb(hex);
        const luminance = this.getLuminance(r, g, b);

        // A threshold for determining light vs. dark colors
        return luminance < 0.5;
    }

}